import * as React from 'react';

function SvgPropertyContractLandlord(props) {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.372a6 6 0 00-6 6V54a6 6 0 006 6h22.57l19.938-17.472.813-27.982a6 6 0 00-5.998-6.174H15z"
        fill="#E4F2EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.226 46.895h10.271c1.194 0 2.162.685 2.162 1.796 0 1.11-.968 1.796-2.162 1.796H8.226c-5.104 0-8.216-2.573-8.216-7.32V7.35C.01 2.603 3.122.03 8.226.03h29.99c5.104 0 8.216 2.572 8.216 7.32v4.726c0 1.11-.737 2.011-1.93 2.011-1.195 0-1.931-.9-1.931-2.01V7.35c0-2.53-1.636-3.728-4.355-3.728H8.226c-2.72 0-4.354 1.198-4.354 3.728v35.816c0 2.53 1.635 3.728 4.354 3.728zM34.51 12.138H11.813c-1.194 0-2.162.685-2.162 1.796 0 1.11.968 1.796 2.162 1.796H34.51c1.194 0 2.162-.686 2.162-1.796 0-1.11-.968-1.796-2.162-1.796zM11.813 23.86c-1.194 0-2.162.685-2.162 1.796 0 1.11.968 1.796 2.162 1.796h13.604c1.194 0 2.162-.686 2.162-1.797 0-1.11-.968-1.795-2.162-1.795H11.813zm.085 10.923c-1.194 0-2.162.686-2.162 1.796 0 1.111.968 1.797 2.162 1.797h4.485c1.194 0 2.162-.686 2.162-1.797 0-1.11-.968-1.796-2.162-1.796h-4.485zm41.378-11.611l-4.731-4.402a1.228 1.228 0 00-1.514-.104l-.13.104-22.082 20.542-.44 3.378c-.36 2.816 1.688 4.788 4.678 4.589l.284-.025 3.632-.41 20.303-18.781 1.825-1.698c.413-.384.45-.984.113-1.408l-.113-.121-1.825-1.664zm-5.496-.666l3.374 3.138-19.661 18.182-.198.09-2.558.283c-.767.064-1.087-.233-1.02-.938l.307-2.389.097-.185 19.66-18.18z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgPropertyContractLandlord;
